import parse from 'html-react-parser';
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import ConnUrls from '../Connections/ConnectURL';
import { MobiOrNotContext } from "../Contexts/MobiOrNot_Context";
import utilsHomePage from '../Connections/_Utils/utilsHomePage';

import { Swiper, SwiperSlide } from "swiper/react";
import styles from './SwiperSection.module.css';
import MobiStyles from './SwiperSectionMobi.module.css';

import 'swiper/css';  // Core styles
import 'swiper/css/navigation';  // Navigation module styles
import 'swiper/css/pagination';  // Pagination module styles
import PlusMinusSelect from './PlusMinusSelect';
import { TheOrderContext } from '../Contexts/TheOrder_Context';
import utilsRestMenus from '../Connections/_Utils/utilsRestMenus';
import PopUpClearComp from '../PopUps/PopUpClearComp';
import ProductOptionsSelect from '../ProductPage/ProductOptionsSelect';

const SwiperSection = (props) => {
  const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
  const { theOrder, setTheOrder, addToTheOrder, updateTheOrd } = useContext(TheOrderContext);
  const [currnetStyle, setCurrentStyle] = useState(!mobiOrNot ? styles : MobiStyles);

  const [timgs, setTimgs] = useState([]);
  const [sectionHeader, setSectionHeader] = useState({});
  const [thePopUp, setThePopUp] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    setCurrentStyle(!mobiOrNot ? styles : MobiStyles);
  }, [mobiOrNot]);

  useEffect(() => {
    setSectionHeader(props.theSectionHeader);
    if (!props.getByIds) {
      setTimgs(props.itemsOfSection);
    } else {
      getSectionsDetails();
    }
  }, [props.itemsOfSection, theOrder]);

  const getSectionsDetails = async () => {
    let tempHomP = await utilsRestMenus.getSectionsDetails(props.itemsOfSection);
    setTimgs(tempHomP);
  };

  const goToProduct = (prodId) => {
    navigate(`/prods/${prodId}`);
  };

  const updateCountVal = (val, itemId) => {
    let tempTimgs = [...timgs];
    let itemIndex = tempTimgs.findIndex(item => item._id === itemId);
    if (itemIndex !== -1) {
      tempTimgs[itemIndex].mount = val || 1;
      setTimgs(tempTimgs);

      if (val === 0) {
        // Remove item from the order if val is 0
        let tempOrder = { ...theOrder };
        let orderItemIndex = tempOrder.items.findIndex(item => item._id === itemId);
        if (orderItemIndex !== -1) {
          tempOrder.items.splice(orderItemIndex, 1);
          updateTheOrd(tempOrder);
        }
      } else {
        let tempOrder = { ...theOrder };
        let orderItemIndex = tempOrder.items.findIndex(item => item._id === itemId);
        if (orderItemIndex === -1) {
          let newItem = tempTimgs.find(item => item._id === itemId);
          if (newItem?.prodOptions?.length > 0) {
            popOptions(newItem);
          } else {
            tempOrder.items.push({ ...newItem, mount: val });
            updateTheOrd(tempOrder);
          }
        } else {
          tempOrder.items[orderItemIndex].mount = val;
          updateTheOrd(tempOrder);
        }
      }
    }
  };

  const addThisItem = (item) => {
    if (item.prodOptions && item.prodOptions.length > 0) {
      popOptions(item);
    } else {
      updtOrAdd(item);
    }
  };

  const updtOrAdd = (item) => {
    let tempOrder = { ...theOrder };
    let orderItemIndex = tempOrder.items.findIndex(ord => ord._id === item._id);
    if (orderItemIndex !== -1) {
      tempOrder.items[orderItemIndex] = item;
    } else {
      tempOrder.items.push(item);
    }
    updateTheOrd(tempOrder);
  };

  const popOptions = (item) => {
    setThePopUp(
      <PopUpClearComp
        BtnTxt={"סגור"}
        title={""}
        noLineStart={true}
        btnFStyle={"fatInBtn"}
        closePop={() => setThePopUp()}
        parentCLose={() => setThePopUp()}
        theInsideComp={
          <ProductOptionsSelect
            saveIt={() => setThePopUp()}
            closePop={() => setThePopUp()}
            item={item}
            options={item.prodOptions}
          />
        }
      />
    );
  };




  return (
    <div className={currnetStyle.HPSection}>
      <div className={currnetStyle.HPSectionHeads}>
        <h2 className={`${currnetStyle.mainHead} regularPoint`}>
          {sectionHeader?.mainHead}
        </h2>
        <div className={`${currnetStyle.secondHead} regularPoint`}>
          {sectionHeader?.secondHead}
        </div>
      </div>
      <Swiper
        modules={[]}
        className={currnetStyle.HPSectionSwiper}
        spaceBetween={5}
        slidesPerView={!mobiOrNot ? 5 : 2}
        pagination={true}
        speed={1000}
        loop={true}
        freeMode={false}
      >
        {
          timgs?.map((item, index) => {
            let prodIsInOrder = theOrder.items?.find(ord => ord._id === item._id);
            item.mount = prodIsInOrder?.mount || 1;

            return (
              <SwiperSlide
                key={index}
                className={`${currnetStyle.HPSectionItm} ${currnetStyle.animate__pulseOut} ${currnetStyle.animate__pulseToIN} animate__animated pointing`}
                onClick={() => goToProduct(item._id)}
              >
                <div className={`${currnetStyle.HPSectionInBlock}`}>
                  <div className={`${currnetStyle.prodImg}`} onClick={() => goToProduct(item._id)}>
                  <img src={item.prodImageUrl !== "" ? ConnUrls.servMediasUrl + item.prodImageUrl : ConnUrls.servMediasUrl + props.mnuItemMainImg}
                    alt={item.altTags || item.prodName || ""} />
                  </div>

                  <div className={`${currnetStyle.prodNameWrap}`}>
                    <div className={`${currnetStyle.prodName} pointing`} onClick={() => goToProduct(item._id)}>
                      {item.prodName}
                    </div>
                  </div>
                  <div className={`${currnetStyle.prodPrice} pointing`} onClick={() => goToProduct(item._id)}>
                    <div className={"centerthisdiv"}>
                      <div className={`${styles.prodPrice} pointing`}><span className={"onRight"}>{item.prodPrice}</span><span className={"onRight"}>₪</span></div>
                    </div>

                  </div>
                  {/* <div className={currnetStyle.PlusMinusSelectWrap}>
                    <PlusMinusSelect
                      css={currnetStyle.PlusMinusSelect}
                      plusBtnStyle={currnetStyle.plusBtn}
                      mountNumStyle={currnetStyle.mountNum}
                      minusBtnStyle={currnetStyle.minusBtn}
                      Mount={item.mount}
                      minCount={1}
                      theVal={(newVal) => updateCountVal(newVal, item._id)}
                    />
                  </div> */}

                  <div className={"fullRow"} style={{ minHeight: '30px' }}>
                    <div className={"wrapinorderTxt"}>
                      <div className={"inOrderP bold big inorderText"} style={{ minHeight: '22px' }}>
                        {prodIsInOrder && "נמצא בהזמנה"}
                      </div>

                    </div>
                  </div>

                  <div className={`${currnetStyle.addToCart} pointing`} onClick={() => goToProduct(item._id)}>
                    {!prodIsInOrder ? "הוספה לסל" : "עדכון ההזמנה"}
                  </div>
                </div>
              </SwiperSlide>
            );
          })
        }
      </Swiper>
      {thePopUp}
    </div >
  );
};

export default SwiperSection;
